import React from 'react';
import useStyle from './tabLeaderboardNav.style';
import { HeaderText } from 'components/atoms/Texts/HeaderText';
import emojis from 'theme/emoji';
import { LeaderboardNav } from '../../../atoms/LeaderboardNav';
import { LeaderBoardCategories } from '../../../../types/leaderboard/leaderboard';
import { CarouselNav } from '../../Carousel/CarouselNav';

interface TabLeaderboardNavProps {
  selected: LeaderBoardCategories;
  setSelected: (value: LeaderBoardCategories) => void;
}

export const TabLeaderboardNav = ({
  selected,
  setSelected
}: TabLeaderboardNavProps) => {
  const classes = useStyle();
  const tabs: LeaderBoardCategories[] = [
    'classe',
    'academie',
    'niveau',
    'national'
  ];

  const nextTab = () => {
    const index = tabs.indexOf(selected);
    if (index < tabs.length - 1) {
      setSelected(tabs[index + 1]);
    }
  };

  const previousTab = () => {
    const index = tabs.indexOf(selected);
    if (index > 0) {
      setSelected(tabs[index - 1]);
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.title}>
        <HeaderText text="Les Classements" emoji={emojis['BarChart']} />
      </div>
      <div className={classes.mobileNav}>
        <CarouselNav
          text={selected}
          next={nextTab}
          previous={previousTab}
          isMobile={false}
        />
      </div>
      <div className={classes.filters}>
        <LeaderboardNav
          niveau={'classe'}
          onClick={() => setSelected('classe')}
          selected={selected === 'classe'}
        />
        <LeaderboardNav
          niveau={'academie'}
          onClick={() => setSelected('academie')}
          selected={selected === 'academie'}
        />
        <LeaderboardNav
          niveau={'niveau'}
          onClick={() => setSelected('niveau')}
          selected={selected === 'niveau'}
        />
        <LeaderboardNav
          niveau={'national'}
          onClick={() => setSelected('national')}
          selected={selected === 'national'}
        />
      </div>
    </div>
  );
};
